export function formatPhoneNumber(phoneNumber) {
    if (!phoneNumber) return '';
    
    // Remove all non-digit characters
    const cleaned = phoneNumber.toString().replace(/\D/g, '');
    
    // Handle Romanian numbers: +40 723 870 735
    // Typical formats: 0723870735 or 40723870735
    if (cleaned.length === 10 && cleaned.startsWith('0')) {
        // format 0723870735 -> +40 723 870 735
        return `+40 ${cleaned.substring(1, 4)} ${cleaned.substring(4, 7)} ${cleaned.substring(7, 10)}`;
    } else if (cleaned.length === 11 && cleaned.startsWith('40')) {
        // format 40723870735 -> +40 723 870 735
        return `+40 ${cleaned.substring(2, 5)} ${cleaned.substring(5, 8)} ${cleaned.substring(8, 11)}`;
    } else if (cleaned.length === 12 && cleaned.startsWith('0040')) {
        // format 0040723870735 -> +40 723 870 735
        return `+40 ${cleaned.substring(4, 7)} ${cleaned.substring(7, 10)} ${cleaned.substring(10, 13)}`;
    }
    
    // Fallback for other formats or international numbers
    // If it starts with a plus, keep it
    if (phoneNumber.toString().trim().startsWith('+')) {
        return phoneNumber;
    }

    return phoneNumber;
}
